import React from "react";
import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { Controller, useForm } from "react-hook-form";
import Text from "../../../../shared/components/Text";
import MainButton from "../../../../shared/components/MainButton";
import IconTitle from "../../../../shared/components/IconTitle";
import { genderTypesConfig } from "../../shared/config";
import { objectTypesConfigToArray } from "../../../../../utils/objectTypesConfigToArray";
import { ICON_TITLE_HEIGHT } from "../../../../../config/config";
import { assetIds, ThemedAsset } from "nemuru-components";

export default function KycManualPersonalInfo({ onSubmitForm, data }) {
  const { palette } = useTheme();

  const { register, getValues, handleSubmit, errors, control } = useForm({
    defaultValues: {
      firstName: data?.firstName,
      lastName: data?.lastName,
      gender: data?.gender || "",
    },
  });

  return (
    <>
      <Box className="appear-anim">
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_ID_FRONT}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId="ID" />}
          subtitle={<Text tId="NAME_SURNAME" />}
        />
        <TextField
          fullWidth
          label={<Text tId={"FIRST_NAME"} />}
          type="text"
          id="firstName"
          name="firstName"
          error={errors.firstName ? true : false}
          helperText={errors.firstName?.message}
          inputProps={{
            ref: register({
              required: {
                value: true,
                message: <Text tId={"REQUIRED_FIELD"} />,
              },
            }),
          }}
        />
        <TextField
          fullWidth
          label={<Text tId={"LAST_NAME"} />}
          type="text"
          id="lastName"
          name="lastName"
          error={errors.lastName ? true : false}
          helperText={errors.lastName?.message}
          inputProps={{
            ref: register({
              required: {
                value: true,
                message: <Text tId={"REQUIRED_FIELD"} />,
              },
            }),
          }}
        />
        <FormControl fullWidth>
          <InputLabel id="gender">
            <Text tId="GENDER" />
          </InputLabel>
          <Controller
            name="gender"
            control={control}
            rules={{
              required: {
                value: true,
                message: <Text tId={"REQUIRED_FIELD"} />,
              },
            }}
            render={(props) => (
              <>
                <Select
                  MenuProps={{
                    MenuListProps: {
                      "aria-label": "Select gender",
                    },
                  }}
                  onChange={(e) => props.onChange(e.target.value)}
                  value={props.value}
                  error={errors.gender ? true : false}
                >
                  {objectTypesConfigToArray(genderTypesConfig).map((type) => (
                    <MenuItem key={type.value} value={type.value}>
                      {type.display}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText style={{ color: palette.error.main }}>
                  {errors.gender?.message}
                </FormHelperText>
              </>
            )}
          />
        </FormControl>
      </Box>
      <Box>
        <MainButton onClick={handleSubmit(() => onSubmitForm(getValues()))} />
      </Box>
    </>
  );
}
